/* Product card badges never overlap (2026-10-25). Styles: assets/rv-collection.css (.rv-badges-stacked).
   Phones (749px and narrower), since 2026-11-01: Best Seller / Top Rated sits top right (like desktop); with two or
   more other badges on the card it is hidden. (10-25 had every badge stacked at the top left.)
   Wider screens: the note stays top right unless it would touch the left badges, then it moves under them.
   A card photo can carry a SALE / SOLD OUT badge at the top left (theme badges) and a Best Seller /
   Top Rated note at the top right (.product-notes-float). On narrow cards (small phones, the
   3-across You May Also Like row, 6-per-row desktop) the two ran into each other. When they would
   touch, the note moves under the left badges instead. Checked again whenever a card changes width
   (View 3/4/6, rotating a phone, resizing) and for cards added later (filters, sliders, You May Also
   Like). */
(function () {
  'use strict';

  var GAP = 6;
  var PHONE = window.matchMedia('(max-width: 749px)');

  function fit(media) {
    var note = media.querySelector(':scope > .product-notes-float, .product-notes-float');
    var group = media.querySelector('.product-badges--position-top.product-badges--position-left');
    var badges = group ? Array.prototype.filter.call(group.querySelectorAll('.product-badge'), function (b) {
      return b.offsetWidth > 0;
    }) : [];
    // NEW / SALE corner tabs (snippets/rv-corner-badges.liquid) sit next to the photo, not in it, but count the same.
    var corner = media.parentElement && media.parentElement.querySelector(':scope > .rv-corner');
    if (corner) badges = badges.concat(Array.prototype.slice.call(corner.children));
    if (!note) {
      media.classList.remove('rv-badges-stacked');
      return;
    }
    // Phones (user, 2026-11-01): Best Seller / Top Rated stays at the top RIGHT like on desktop. When the card already
    // has two or more other badges (e.g. NEW + SALE), the note is left off so the photo doesn't get crowded.
    if (PHONE.matches) {
      media.classList.remove('rv-badges-stacked');
      media.style.removeProperty('--rv-note-top');
      note.classList.toggle('rv-note-off', badges.length >= 2);
      return;
    }
    note.classList.remove('rv-note-off');
    if (!badges.length) {
      // Phones: a lone note goes to the top left like every other badge.
      media.style.removeProperty('--rv-note-top');
      media.classList.toggle('rv-badges-stacked', PHONE.matches);
      return;
    }
    // Measure in the side-by-side layout (no paint happens between these lines).
    media.classList.remove('rv-badges-stacked');
    var noteLeft = note.getBoundingClientRect().left;
    var right = 0;
    var bottom = 0;
    badges.forEach(function (b) {
      var r = b.getBoundingClientRect();
      right = Math.max(right, r.right);
      bottom = Math.max(bottom, r.bottom);
    });
    if (PHONE.matches || noteLeft < right + GAP) {
      media.style.setProperty('--rv-note-top', Math.round(bottom - media.getBoundingClientRect().top + 4) + 'px');
      media.classList.add('rv-badges-stacked');
    }
  }

  var observer = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { fit(entry.target); });
  }) : null;

  function setupAll() {
    document.querySelectorAll('.product-item__media').forEach(function (media) {
      if (!media.querySelector('.product-notes-float')) return;
      if (!media.__rvCardFit) {
        media.__rvCardFit = true;
        if (observer) observer.observe(media);
      }
      fit(media);
    });
  }

  var pending;
  function later() {
    clearTimeout(pending);
    pending = setTimeout(setupAll, 100);
  }

  function start() {
    setupAll();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) return later();
      }
    }).observe(document.body, { childList: true, subtree: true });
    // Badge text sizes depend on the web font; measure again once it is in.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setupAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', setupAll);
  if (PHONE.addEventListener) PHONE.addEventListener('change', setupAll);
})();
